var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgManagerIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 117.57,
    height: 87.291,
    viewBox: "0 0 117.57 87.291",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_212",
    "data-name": "Group 212",
    transform: "translate(-5154.202 -3779.761)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_181",
    "data-name": "Path 181",
    d: "M99.437,81.933a1.1,1.1,0,0,1-1.1-1.1V78.783a1.1,1.1,0,0,1,2.193,0v2.054a1.1,1.1,0,0,1-1.1,1.1",
    transform: "translate(5128.358 3759.471)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_182",
    "data-name": "Path 182",
    d: "M112.711,80.928a1.1,1.1,0,0,1-1.1-1.1V75.047a1.1,1.1,0,1,1,2.193,0v4.785a1.1,1.1,0,0,1-1.1,1.1",
    transform: "translate(5124.789 3760.476)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_183",
    "data-name": "Path 183",
    d: "M125.986,79.283a1.1,1.1,0,0,1-1.1-1.1V68.927a1.1,1.1,0,1,1,2.193,0v9.259a1.1,1.1,0,0,1-1.1,1.1",
    transform: "translate(5121.219 3762.122)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_184",
    "data-name": "Path 184",
    d: "M139.26,77.741a1.1,1.1,0,0,1-1.1-1.1V63.194a1.1,1.1,0,0,1,2.193,0V76.644a1.1,1.1,0,0,1-1.1,1.1",
    transform: "translate(5117.649 3763.663)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_185",
    "data-name": "Path 185",
    d: "M47.522,14.816a1.1,1.1,0,0,1-1.1-1.1V9.87A9.881,9.881,0,0,1,56.295,0H94.931a1.1,1.1,0,0,1,0,2.193H56.295A7.685,7.685,0,0,0,48.618,9.87v3.85a1.1,1.1,0,0,1-1.1,1.1",
    transform: "translate(5142.318 3780.361)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_186",
    "data-name": "Path 186",
    d: "M130.812,75.977h-39.3a1.1,1.1,0,0,1,0-2.193h39.3a7.685,7.685,0,0,0,7.677-7.677V9.87a7.685,7.685,0,0,0-7.677-7.677H105.906a1.1,1.1,0,1,1,0-2.193h24.906a9.881,9.881,0,0,1,9.87,9.87V66.107a9.881,9.881,0,0,1-9.87,9.87",
    transform: "translate(5130.489 3780.361)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_187",
    "data-name": "Path 187",
    d: "M107.372,41.835a1.1,1.1,0,0,1-.83-.379L97.117,30.712l-14.1,12.681a1.1,1.1,0,1,1-1.047-1.927L96.8,28.157a1.1,1.1,0,0,1,1.352.245l9.145,10.567,14.359-19.993a1.1,1.1,0,0,1,1.782,1.279l-15.17,21.121a1.1,1.1,0,0,1-.842.456h-.049",
    transform: "translate(5132.915 3775.381)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_188",
    "data-name": "Path 188",
    d: "M134.93,31.028a1.1,1.1,0,0,1-1.084-.944l-1.3-9.231-9.231,1.3a1.1,1.1,0,1,1-.306-2.171l10.317-1.45a1.094,1.094,0,0,1,1.239.934l1.45,10.317a1.1,1.1,0,0,1-.933,1.238,1.11,1.11,0,0,1-.154.011",
    transform: "translate(5121.977 3775.382)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_189",
    "data-name": "Path 189",
    d: "M35.787,63.269c-10.141,0-18.391-8.483-18.391-18.91s8.25-18.91,18.391-18.91,18.391,8.483,18.391,18.91-8.25,18.91-18.391,18.91m0-35.261A16.116,16.116,0,0,0,19.955,44.359,16.116,16.116,0,0,0,35.787,60.71,16.116,16.116,0,0,0,51.619,44.359,16.116,16.116,0,0,0,35.787,28.008",
    transform: "translate(5150.124 3773.518)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_190",
    "data-name": "Path 190",
    d: "M41.016,106.162H1.279A1.28,1.28,0,0,1,0,104.883V97.432a26.175,26.175,0,0,1,13.058-22.62,1.279,1.279,0,0,1,1.279,2.216,23.612,23.612,0,0,0-11.778,20.4V103.6H41.016a1.279,1.279,0,0,1,0,2.559",
    transform: "translate(5154.802 3760.291)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_191",
    "data-name": "Path 191",
    d: "M78.24,106.162H70.788a1.279,1.279,0,0,1,0-2.559H76.96V97.432a23.612,23.612,0,0,0-11.778-20.4,1.279,1.279,0,0,1,1.279-2.216A26.177,26.177,0,0,1,79.519,97.433v7.45a1.28,1.28,0,0,1-1.279,1.279",
    transform: "translate(5137.446 3760.29)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 1.2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgManagerIcon);
export default __webpack_public_path__ + "static/media/manager-icon.6461f5eb0d1dcc99039d2f5262d30bbf.svg";
export { ForwardRef as ReactComponent };